import React from 'react';
import { visitInfo } from '../data/site';
const embedSrc = `https://www.google.com/maps?q=${encodeURIComponent(visitInfo.address)}&z=16&hl=en&output=embed`;

/**
 * Live Google Maps view of the corner the cafe sits on, tinted into the
 * house palette so it reads as another frame of the film rather than a widget.
 */
export function LocationMap() {
  return <div className="relative h-full w-full bg-ink" data-id="element-29" data-mp="1b1mxpkk3a9td">
      <iframe title="Google Map showing Wabash & Roast at 663 Wabash Ave, Terre Haute, Indiana" src={embedSrc} className="map-google h-full w-full border-0" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" data-id="element-30" data-mp="1yqfpr5xlbxip" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[#4a3416] opacity-25 mix-blend-color" data-id="element-31" data-mp="1txwc68ywl2dw" />
    </div>;
}